import {Asset, AssetClass, Instrument} from "../../api/api";
import {createSlice} from "@reduxjs/toolkit";
import {setter} from "../utils/setter";

export interface AssetsState {
  classes?: AssetClass[]
  list?: Asset[],
  instruments?: Instrument[]
}

const initialState: AssetsState = {}

export const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    setClasses: setter(initialState, 'classes'),
    setList: setter(initialState, 'list'),
    setInstrument: setter(initialState, 'instruments')
  }
})
